namespace AgerLMS.LMS {
    export enum AfterGraduationInstitutions {
        PrivateHospital = 1,
        StateHospital = 2,
        UniversityHospital = 3,
        TrainingAndResearchHospital = 4,
        CityHospital = 5,
        Other = 6
    }
    Serenity.Decorators.registerEnumType(AfterGraduationInstitutions, 'AgerLMS.LMS.AfterGraduationInstitutions');
}
